export * from './personalization-dialog-prompt-proxy.component';
